import { useQuery } from '@apollo/client';
import { graphql } from '../gql';
import { useMemo } from 'react';
import { getFirstPaginatedNode, getPaginationTotalResults } from './utils';

export const GET_ENTITIES_ATTACK_SURFACE_COUNTS = graphql(`
  query getEntitiesAttackSurfaceCounts($submissionUuid: String!) {
    entities(
      filters: { submissionUuid: $submissionUuid, submissionType: INSURED }
    ) {
      pageInfo {
        totalResults
      }
      edges {
        cursor
        node {
          domains {
            pageInfo {
              totalResults
            }
          }
          softwares {
            edges {
              cursor
              node {
                vulnerabilities {
                  pageInfo {
                    totalResults
                  }
                }
              }
            }
          }
          ipAddresses {
            pageInfo {
              totalResults
            }
            edges {
              cursor
              node {
                ports {
                  edges {
                    node {
                      port
                      protocol
                    }
                  }
                  pageInfo {
                    totalResults
                  }
                }
                uuid
                software {
                  edges {
                    node {
                      ports {
                        edges {
                          node {
                            port
                            protocol
                          }
                        }
                        pageInfo {
                          totalResults
                        }
                      }
                    }
                  }
                  pageInfo {
                    totalResults
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);

export function useEntitiesAttackSurfaceCountsQuery(submissionUuid: string) {
  const { loading, error, data } = useQuery(
    GET_ENTITIES_ATTACK_SURFACE_COUNTS,
    {
      variables: {
        submissionUuid,
      },
    }
  );
  const counts = useMemo(() => {
    const entity = getFirstPaginatedNode(data?.entities);
    return {
      domains: getPaginationTotalResults(entity?.domains),
      ipAddresses: entity?.ipAddresses.pageInfo.totalResults,
      openPorts: entity?.ipAddresses.edges?.reduce((accumulator, curValue) => {
        const portsCount = curValue?.node?.ports?.pageInfo.totalResults;

        return accumulator + portsCount;
      }, 0),
      vulnerabilities: entity?.softwares?.edges?.reduce(
        (accumulator, curValue) => {
          return (
            accumulator + curValue.node.vulnerabilities.pageInfo.totalResults
          );
        },
        0
      ),
    };
  }, [data]);
  return {
    error,
    loading,
    data,
    counts,
  };
}
